import { QueryOptions } from "@apollo/client";

export const UNAUTHORIZED = "Unauthorized";
export const TOKEN_INVALID = "Token Invalid";
export const FORGET_PASSWORD = "Forgot Password?";
export const TOKEN_NOT_FOUND = "Token not found";
export const UNAUTHENTICATED = "UNAUTHENTICATED";
export const REQUEST_NOT_FOUND = "Requests not found for current user.";
export const CONFLICT_EXCEPTION = "Conflict Exception";
export const INVALID_AUTH_TOKEN =
  "Invalid Authorization Token - Expired or Invalid.";
export const NOT_FOUND_EXCEPTION = "Not Found Exception";
export const SOMETHING_WENT_WRONG = "Something went wrong";
export const PRECONDITION_FAILED_EXCEPTION = "Precondition Failed Exception";
export const INVALID_OR_EXPIRED_TOKEN_MESSAGE =
  "Sorry! Your token is expired or invalid.";
export const CASE_HAS_BEEN_CLOSED_UNABLE_TO_UPDATE =
  "Case has been closed unable to update";
export const USER_AGREE = "User must agree to the Terms of Services & Privacy Policy in order to continue.";
export const ALPHABETS_REGEX_VALIDATION =
  "special characters, digits, and spaces at the end are not allowed";
export const ALPHABETS_REGEX = /^\b(?!.*?\s{2})[A-Za-z ]{1,}\b$/;
export const ALPHABETS_NULLABLE_REGEX = /^(\b(?!.*?\s{2})[A-Za-z ]{0,}\b)?$/;
export const DATE_FORMAT = "MM/DD/YYYY";
export const TIME_FORMAT = "h:mm:ss a";
export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()\-_=+{}\[\]|;:'",.<>/?]).{8,}$/;
export const PASSWORD_IS_INVALID = "Password is invalid.";
export const WDIC_ALERT = "wdic_alert";

export const FOUR_O_FOUR = "404";
export const PAGE_NOT_FOUND = "Page Not Found";
export const LOOKS_LIKE_AN_EMPTY_SPACE =
  "Looks like an empty space. You can go back to homepage by clicking the button below.";

export const SPAM_FOLDER_TEXT = "Please check your spam folder if you didn't receive the email in your inbox.";
export const VERIFY_EMAIL_TITLE = "Please check your email!";
export const VERIFY_EMAIL_BODY_PREFIX = "We have emailed you a verification link to your email address ";
export const VERIFY_EMAIL_BODY_SUFFIX = ". Use the link to verify your email.";
export const BUTTON_TEXT_BACK_TO_LOGIN = "Back to login";
export const BUTTON_TEXT_REGISTER = "Register";
export const BUTTON_TEXT_RESET_PASSWORD = "Reset Password";
export const BUTTON_TEXT_UPDATE_PASSWORD = "Update Password";
export const BUTTON_TEXT_GET_STARTED = "Get a Membership";
export const BUTTON_TEXT_SIGN_UP = "Sign Up";
export const TEXT_DONT_HAVE_ACCOUNT = "Don't have an account? ";
export const TEXT_ALREADY_HAVE_ACCOUNT = "Already have an account? ";
export const WHODOICALL_URL = "http://855whodoicall.com";
export const AUTH_TOKEN = "WDIC_TOKEN";

/** Canonical brand name — change here to update every usage across admin and portal. */
export const BRAND_NAME = "WhoDoICall";
export const BRAND_NAME_FULL = `855${BRAND_NAME}™`;
export const LABEL_855 = '855';
export const LABEL_TM = '™';
export const LABEL_RING_MY_PHONE_TM = 'Ring My Phone™';
export const BRAND_NAME_DOT_COM = '855WhoDoICall.com';
export const LABEL_WELCOME_TO_BRAND_DOT_COM = 'Welcome to 855WhoDoICall.com!';
export const PHONE_NO_CONSENT_TEXT = `I authorize ${BRAND_NAME_FULL} to display my phone number as the caller ID to my trusted contacts when I call them through ${BRAND_NAME_FULL} from any phone.`;
export const APP_NAME = "APP_NAME";

export enum CardBrands {
  VISA = "visa",
  MASTERCARD = "mastercard",
  American_Express = "american express",
  DISCOVER = "discover",
  GENERIC = "generic",
  DINERSCLUB = "diners club",
}

export enum APP_NAMES {
  ADMIN = "ADMIN",
  PORTAL = "PORTAL",
}

export const GRAPHQL_QUERY_POLICY = {
  fetchPolicy: "network-only",
  nextFetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: true,
} as unknown as QueryOptions;

// Admin UI — page headings
export const PAGE_TITLE_WELCOME = "Hello! Welcome, 👋";
export const PAGE_TITLE_LOGIN = "Sign In to 855WhoDoICall.com Admin";
export const PAGE_SUBTITLE_LOGIN = "Enter Your Details Below";
export const PAGE_TITLE_SIGNUP = "Welcome To 855WhoDoICall.com Admin";
export const PAGE_TITLE_LOGIN_PORTAL = 'Sign In to 855WhoDoICall.com';
export const PAGE_TITLE_SIGNUP_PORTAL = 'Start Your Free Trial in Just a Few Clicks';
export const PAGE_SUBTITLE_SIGNUP_PORTAL = "Let's Get Started";
export const PAGE_SUBTITLE_SIGNUP =
  "Please Fill Out The Information To Complete.";
export const PAGE_TITLE_FORGOT_PASSWORD = "Forgot Your Password?";
export const PAGE_SUBTITLE_FORGOT_PASSWORD =
  "Please enter the email address associated with your account, and we'll email you a link to reset your password.";
export const PAGE_TITLE_RESET_PASSWORD = "Change Password";
export const PAGE_TITLE_ACTIVE_PROMO_CODE_USERS = "Active Promo Code Users";
export const PAGE_TITLE_CREATE_NEW_PROMO_CODE = "Create New Promo Code";
export const PAGE_TITLE_REFERRAL_SOURCE_LIST = "Referral Source List";
export const PAGE_TITLE_TRANSACTION_HISTORY_SECTION = "Transaction History";
export const PAGE_TITLE_BILLING_ADDRESS_SECTION = "Billing Address";
export const PAGE_TITLE_PROMO_USED_SECTION = "Promo Used";
export const PASSWORD_VALIDATION_MESSAGE = 'Password must contain at least 8 characters, at least 1 uppercase, at least 1 number, and at least 1 special case character.';
export const INVALID_EMAIL = 'Email address is invalid.';

// Billing / address labels
export const PLACEHOLDER_ENTER_STREET_ADDRESS = "Enter Street Address";
export const PLACEHOLDER_ENTER_APARTMENT_SUITE = "Enter Apartment, Suite, etc.";
export const PLACEHOLDER_ENTER_CITY = "Enter City";
export const PLACEHOLDER_ENTER_ZIP_CODE = "Enter ZIP Code";
export const LABEL_PROTECTED_SINCE = "Protected Since";
export const LABEL_NEXT_BILLING_DATE = "Next Billing Date";
export const LABEL_EXPIRATION_DATE = "Expiration Date";
export const LABEL_CREDIT = "Credit";
export const LABEL_FREE_PLAN = "Free Plan";
export const LABEL_FEATURES = "Features";
export const LABEL_NO_ACTIVE_SUBSCRIPTION = "No Active Subscription";
export const LABEL_YOUR_PLAN = "Your Plan";
export const BUTTON_TEXT_SUBSCRIBE_PLAN = "Subscribe Plan";
export const LABEL_STREET_ADDRESS = "Street Address";
export const LABEL_COUNTRY = "Country";
export const LABEL_STATE = "State";
export const LABEL_CITY = "City";
export const LABEL_ZIP_CODE = "Zip Code";
export const LABEL_STREET_ADDRESS_LINE_1 = "Street Address Line 1";
export const LABEL_STREET_ADDRESS_LINE_2 = "Street Address Line 2";
export const MSG_BILLING_ADDRESS_UPDATED = "Billing address has been updated successfully.";
export const BUTTON_TEXT_EDIT_BILLING_ADDRESS = "Edit Billing Address";
export const BUTTON_TEXT_UPDATE_BILLING_ADDRESS = "Update Billing Address";
export const LABEL_COUPON = "Coupon";
export const LABEL_CUSTOMER = "Customer";
export const LABEL_ACTIONS = "Actions";
export const LABEL_USER_STATUS = "User Status";
export const LABEL_DISCOUNT = "Discount";
export const LABEL_AMOUNT = "Amount";
export const LABEL_RECEIPT = "Receipt";
export const LABEL_DETAILS = "Details";
export const LABEL_CREATED_AT = "Created At";
export const LABEL_DISCOUNT_PERIOD = "Discount Period";
export const LABEL_SALES = "Sales";
export const LABEL_REDEEMED = "Redeemed";
export const LABEL_DURATION = "Duration";
export const LABEL_SALES_YES = "Yes";
export const LABEL_SALES_NO = "No";
export const LABEL_DELETE_PROMO_CODE = "Delete Promo Code";
export const LABEL_EDIT_PROMO_CODE = "Edit Promo Code";
export const LABEL_SHOW_PREVIEW = "Show Preview";
export const LABEL_DELETE_CONTACT = "Delete Contact";
export const LABEL_PAYMENT_METHOD = "Payment Method";
export const LABEL_CURRENT_MONTH_USAGE = "Current Month's Usage";
export const LABEL_OVER_ALL_USAGE = "OverAll Usage";
export const LABEL_CURRENT_PLAN = "Current Plan";
export const LABEL_NOT_ASSIGNED = "Not Assigned";
export const LABEL_ACTIVATE_ACCOUNT = "Activate Account";
export const LABEL_DEACTIVATE_ACCOUNT = "Deactivate Account";
export const LABEL_MAX_REDEMPTIONS = "Max Redemptions";
export const LABEL_VIEW_DETAILS = "View Details";

// Customer & staff dashboard
export const CUSTOMER_LIST_TAB_LABEL = "Customer List";
export const ADMIN_LIST_TAB_LABEL = "Admin List";
export const STAFF_LIST_TAB_LABEL = "Sales Staff";
export const SUBSCRIPTION_PLAN_TAB_LABEL = "Subscription Plan";
export const SUBSCRIPTION_SETTINGS_HEADING = "Subscription Settings";
export const BUTTON_TEXT_INVITE = "Invite";
export const BUTTON_TEXT_LOGIN = "Log In";

// Customer settings tabs
export const CUSTOMER_SETTINGS_TAB_ACCOUNT_DETAILS = "Account Details";
export const LABEL_CONTACT_US_TITLE = "Contact Us";
export const LABEL_CONTACT_US_SUBTITLE = "Get in touch with our support team.";
export const LABEL_CONTACT_INFORMATION = "Contact Information";
export const WDIC_SUPPORT_PHONE = "+16163860653";
export const WDIC_SUPPORT_EMAIL = "support@855whodoicall.com";
export const CUSTOMER_SETTINGS_TAB_CONTACT_LIST = "Contact List";
export const CUSTOMER_SETTINGS_TAB_BILLING_INFO = "Billing Info";
export const CUSTOMER_SETTINGS_TAB_TRANSACTION_HISTORY = "Transaction History";
export const CUSTOMER_SETTINGS_TAB_CALL_SERVICE_USAGE = "Call/Service Usage";

// Account settings tabs (mobile)
export const ACCOUNT_SETTINGS_TAB_DETAILS = "Details";
export const ACCOUNT_SETTINGS_TAB_SECURITY = "Security";
export const ACCOUNT_SETTINGS_TAB_BILLING = "Billing";

// Shared labels & buttons
export const LABEL_SEARCH = "Search";
export const LABEL_STATUS = "Status";
export const LABEL_ROLE = "Role";
export const LABEL_NAME = "Name";
export const PLACEHOLDER_SELECT_SALES_USER = "Select Owner";
export const LABEL_ENTER_PLANS = "Enter Plans";
export const PLACEHOLDER_PLANS = "Plans";
export const LABEL_DISCOUNT_TYPE = "Discount Type";
export const LABEL_SELECT_FREQUENCY = "Select Frequency";
export const LABEL_FREQUENCY = "Frequency";
export const LABEL_EXPIRES_AT = "Expiry";
export const LABEL_START_EXPIRY_DATE = "Start Date Expiry";
export const LABEL_CALL_COST_STARTING = "Calling Fees' Waiver Start Date";
export const LABEL_CALL_COST_ENDING = "Calling Fees' Waiver End Date";
export const LABEL_PROMO_CODE = "Promo Code";
export const LABEL_PROMO_TITLE = "Promo Title";
export const BUTTON_TEXT_GENERATE = "Generate";
export const LABEL_NO_OF_USERS = "Max. Promo Users";
export const TOOLTIP_NO_OF_USERS =
  "This is the maximum amount of users that can use this promo code.";
export const LABEL_MAX_DURATION = "Max. Duration";
export const LABEL_DESCRIPTION = "Description";
export const LABEL_FREE_PROMO_CODE_CALL_COST = "Calling Fees Waiver";
export const LABEL_VALUE = "Value";
export const BUTTON_TEXT_CANCEL = "Cancel";
export const BUTTON_TEXT_CONTINUE = "Continue";
export const BUTTON_TEXT_CHANGE_PIN = "Change PIN";
export const BUTTON_TEXT_VERIFY_OTP = "Verify OTP";
export const BUTTON_TEXT_RESEND_OTP = "Resend OTP";
export const BUTTON_TEXT_RESENDING = "Resending...";
export const BUTTON_TEXT_UPDATE = "Update";
export const BUTTON_TEXT_CREATE = "Create";
export const BUTTON_TEXT_NEW_PROMO_CODE = "New Promo Code";
export const BUTTON_TEXT_CHANGE_PASSWORD = "Change Password";
export const BUTTON_TEXT_CLEAR = "Clear";
export const BUTTON_TEXT_LOAD_MORE = "Load More";
export const BUTTON_TEXT_DOWNLOAD_CSV = "Download CSV";
export const BUTTON_TEXT_LOADING = "Loading...";
export const BUTTON_TEXT_RESET = "Reset";
export const LABEL_SUBSCRIBED_ON = "Subscribed On";
export const LABEL_FROM_DATE = "From Date";
export const LABEL_TO_DATE = "To Date";
export const NO_RECORDS = "No Record(s)";

// Tooltips
export const TOOLTIP_RESET_FILTER = "Reset Filter.";
export const TOOLTIP_PROMO_CODE_DETAILS = "Click to view promo code details.";
export const TOOLTIP_PROMO_SEARCH =
  "Please add the full name of the promo code and press enter to search.";
export const TOOLTIP_PREVIEW_LINK = "Preview";
export const TOOLTIP_GENERATE_QR_CODE = "Generate QR Code";
export const TOOLTIP_EDIT_PROMO = "Edit";
export const TOOLTIP_BACK_PROMO = "Back";
export const INFO_PROMO_MAX_DURATION =
  "This is the maximum duration of months this promo code will apply.";
export const INFO_PROMO_CALL_COST_DATES =
  "Specify the range of dates standard calling fees will be waived.";

// Promo Code / promo tables & dialogs
export const LABEL_PERCENTAGE = "Percentage";
export const LABEL_REPEATING = "Repeating";
export const LABEL_ONCE = "Once";
export const LABEL_FOREVER = "Forever";
export const LABEL_APPLIES_TO = "Applies To";
export const LABEL_NO_LIMIT = "No limit";
export const LABEL_FOR_PHONE = "For Phone";
export const LABEL_FREE_CALL_DURATION = "Free Call Duration";
export const LABEL_START_DATE = "Start Date";
export const LABEL_END_DATE = "End Date";
export const LABEL_PAID = "Paid";
export const LABEL_TRIAL_DAYS = "Trial Days";
export const LABEL_PRIORITY_NUMBER = "Priority #";
export const LABEL_DECLINED_COUNT = "Declined Count";
export const LABEL_RESEND_OPT_IN_LINK = "Resend Opt-In Link";
export const MSG_NO_COUPON_DETAILS = "No details found for this coupon.";
export const TOOLTIP_VIEW_ACTIVE_COUPON_USERS = "Click to view the active coupon users.";
export const PROMO_CODE_USERS_COL_NO = "No.";
export const PROMO_CODE_USERS_COL_PROMO_CODE_USERS = "Promo Code Users";
export const PROMO_CODE_USERS_COL_DATE = "Date";
export const DIALOG_TITLE_PROMO_CODE_DETAILS = "Promo Code Details";
export const TYPOGRAPHY_LOADING = "Loading...";

// Admin header menu
export const MENU_ITEM_ACCOUNT_SETTINGS = "Account Settings";
export const MENU_ITEM_LOGOUT = "Logout";

// Social source dialogs
export const DIALOG_TITLE_REMOVE_REFERRAL_SOURCE = "Remove Referral Source";
export const DIALOG_BODY_REMOVE_REFERRAL_SOURCE =
  "Are you sure you want to remove this referral source?";
export const DIALOG_TITLE_EDIT_REFERRAL_SOURCE = "Edit Referral Source";
export const DIALOG_TITLE_ADD_REFERRAL_SOURCE = "New Referral Source";

// Customer / user UI
export const LABEL_NICKNAME = "Nickname";
export const LABEL_NAME_OF_PERSON = "Name of Contact";
export const PLACEHOLDER_EMAIL_OPTIONAL = "Email (Optional)";
export const PHONE_TYPE_CELL = "Cell";
export const PHONE_TYPE_LANDLINE = "Landline";
export const BUTTON_TEXT_ADD_CONTACT = "Add Contact";
export const BUTTON_TEXT_UPDATE_CONTACT = "Update Contact";
export const BUTTON_TEXT_APPLY = "Apply";
export const LABEL_SUMMARY = "Summary";
export const LABEL_TOTAL_BILLED = "Total Billed";
export const LABEL_FULL_NAME = "Full Name";
export const TYPOGRAPHY_NO_CONTACTS_AVAILABLE = "No contacts available";
export const LABEL_SALES_PERSON = "Sales Person";
export const LABEL_ADMIN = "Admin";
export const LABEL_PLAN = "Plan";
export const FILTER_OPTION_ALL = "All";
export const FILTER_STATUS_ACTIVE = "Active";
export const FILTER_STATUS_PENDING = "Pending";
export const FILTER_STATUS_DEACTIVATED = "Deactivated";

// Delete customer dialog
export const DIALOG_TITLE_DELETE_CUSTOMER = "Delete Customer?";
export const DELETE_CUSTOMER_PROMPT_PREFIX =
  "Are you sure you want to permanently delete";
export const DELETE_CUSTOMER_FALLBACK_NAME = "this customer";
export const DELETE_CUSTOMER_UNDO_LINE = "This action";
export const DELETE_CUSTOMER_UNDO_STRONG = "cannot be undone";
export const DELETE_CUSTOMER_DATA_REMOVED =
  "The following data will be permanently removed:";
export const DELETE_CUSTOMER_LIST_PHONE_NUMBERS = "Phone Numbers";
export const DELETE_CUSTOMER_LIST_SUBSCRIPTIONS =
  "Active & Past Subscriptions";
export const DELETE_CUSTOMER_LIST_CONTACTS = "Contacts & Trusted Contacts";
export const DELETE_CUSTOMER_LIST_CALL_HISTORY =
  "Call History & Related Records";
export const BUTTON_TEXT_DELETE_CUSTOMER = "Delete Customer";
export const BUTTON_TEXT_DELETING = "Deleting…";
export const LABEL_DELETE = "Delete";

// Invite modal
export const INVITE_MODAL_PREFIX = "Invite New";
export const INVITE_MODAL_EMAIL_NOTICE =
  "Sign up instructions will be sent to their email.";
export const ALERT_EMAIL_SENT_SUCCESS = "Email has been sent successfully.";
export const BUTTON_TEXT_SEND_INVITE = "Send Invite";
export const BUTTON_TEXT_SAVE = "Save";
export const BUTTON_TEXT_SAVING = "Saving...";
export const MENU_ITEM_EDIT = "Edit";
export const MENU_ITEM_REMOVE = "Remove";
export const MENU_ITEM_ACTIVATE = "Activate";
export const MENU_ITEM_DEACTIVATE = "Deactivate";
export const BUTTON_TEXT_REMOVING = "Removing...";
export const ALERT_REFERRAL_SOURCE_UPDATED =
  "Referral source updated successfully.";
export const ALERT_PROMO_TITLE_DESCRIPTION_UPDATED =
  "Promo title and description updated successfully.";
export const ALERT_REFERRAL_SOURCE_REMOVED =
  "Referral source removed successfully.";
export const BUTTON_TEXT_CLOSE = "Close";
export const MODAL_TITLE_ADMIN_DETAILS = "Edit Details";
export const ALERT_EMAIL_SENT_SUCCESS_SHORT = "Email sent successfully.";
export const CUSTOMER_MODAL_BASIC_INFORMATION = "Basic Information";
export const LABEL_SUBSCRIPTION = "Subscription";
export const CUSTOMER_MODAL_CONTACTS_ACTIVITY = "Contacts / Activity";
export const LABEL_EMAIL = "Email";
export const LABEL_PHONE = "Phone";
export const LABEL_PASSWORD = "Password";
export const LABEL_ACCOUNT_PASSWORD = "Account Password";
export const LABEL_CONFIRM_PASSWORD = "Confirm Password";
export const LABEL_CONFIRM_NEW_PASSWORD = "Confirm New Password";
export const LABEL_CONFIRM_EMAIL = "Confirm Email";
export const LABEL_NEW_EMAIL = "New Email";
export const LABEL_CURRENT_PASSWORD = "Current Password";
export const LABEL_NEW_PASSWORD = "New Password";
export const LABEL_SIGNUP_DATE = "Signup Date";
export const LABEL_CONTACT = "Contact";
export const DETAIL_LABEL_SUBSCRIPTION_STATUS = "Subscription Status:";
export const DETAIL_LABEL_SUBSCRIBED_ON = "Subscribed On:";
export const DETAIL_LABEL_NEXT_BILLING = "Next Billing:";
export const DETAIL_LABEL_EXPIRED_ON = "Expired On:";
export const LABEL_NOT_AVAILABLE = "N/A";
export const STATUS_LABEL_EXPIRED = "Expired";
export const CUSTOMER_DETAILS_TITLE_SUFFIX = "'s Details";

// For customer specific constants
export const LABEL_FIRST_NAME = "First Name";
export const LABEL_LAST_NAME = "Last Name";
export const LABEL_RING_MY_PHONE = "Ring My Phone";
export const LABEL_RING_MY_PHONE_LOGS = "Logs";
export const LABEL_RING_MY_PHONE_SETTINGS = "Settings";
export const LABEL_RING_MY_PHONE_INFO = "RMP™ Info";
export const LABEL_CHANGE_CARD = "Change Card";
export const LABEL_CHANGE_PLAN = "Change Plan";
export const LABEL_SECURITY_CODE = "Security Code";
export const LABEL_SECURITY_CODE_PIN = "Secure Calling PIN";
export const LABEL_EDIT_CONTACT = "Edit Contact";
export const LABEL_EDIT_EMAIL = "Edit Email";
export const LABEL_ADD_CONTACT = "Add Contact";
export const LABEL_NICK_NAME = "Nickname";
export const LABEL_PHONE_TYPE = "Phone Type";
export const LABEL_PHONE_NUMBER = "Phone Number";
export const LABEL_YOUR_MOBILE_PHONE_NUMBER = "Your Mobile Phone Number";
export const NOTE_YOUR_MOBILE_PHONE_NUMBER = "This should be your personal phone number. This is the number that will be attached to your account. When your phone is unavailable, you'll be able to call through 855WhoDoICall™ from any phone, and this is the number that will appear on the caller ID of the phones you'll call.";
export const LABEL_CHANGE_PAYMENT_METHOD = "Change Payment Method";
export const LABEL_SECURE_PONELESS_SERVICES = "Secure Phonelessness Services by";
export const LABEL_YEAR_COPYRIGHT_REGISTERED = `© 2018-${new Date().getFullYear()}`;
export const COMPANY_NAME = "Fallback Services, LLC";
export const COMPANY_NAME_RIGHTS = "Fallback Services, LLC™";

// Sales coupon public page (portal)
export const SALES_COUPON_PAGE_HEADING = "Promo Offer";
export const SALES_COUPON_ERROR_HEADING = "Invalid or Expired Coupon";
export const SALES_COUPON_ERROR_BODY =
  "This Promo Code is No Longer Valid. Please Use the Link Provided to You or Contact Support.";
export const SALES_COUPON_USE_PROMO_TITLE = "🎁 Use This Promo Code";
export const SALES_COUPON_USE_PROMO_BODY =
  `Download ${BRAND_NAME_FULL} and Use This Promo Code When Signing Up.`;
export const SALES_COUPON_BUTTON_USE_PROMO_PREFIX = "Use Promo Code:";
export const SALES_COUPON_GET_APP_TITLE = "Get the App";
export const SALES_COUPON_GET_APP_BODY = "Download It Now";
export const SALES_COUPON_ALT_GOOGLE_PLAY = "Get It on Google Play";
export const SALES_COUPON_ALT_APP_STORE = "Download on the App Store";
export const SALES_COUPON_ALT_BRAND = BRAND_NAME_FULL;
export const SALES_COUPON_CTA_SIGNUP = "Sign Up Now";
export const SALES_COUPON_LABEL_EXPIRATION_DATE = "Expiration Date";
export const SALES_COUPON_STATUS_INACTIVE = "Inactive";
export const LABEL_GENERATE_QR = "Generate QR";
export const DIALOG_TITLE_PROMO_QR_CODE = "Promo QR Code";
export const BUTTON_TEXT_DOWNLOAD = "Download";
export const BUTTON_TEXT_DOWNLOAD_SVG = "Download SVG";
export const BUTTON_TEXT_DOWNLOAD_PNG = "Download PNG";
export const BUTTON_TEXT_DOWNLOAD_PDF = "Download PDF";

export const LABEL_ACTIVE_CONTACTS = "Active Contact(s)";
export const LABEL_CONTACTS_OPTED_OUT = "Declined Contact(s)";
export const CUSTOMER_SETTINGS_TAB_CONTACT_LIST_EMPTY_MSG = "No Active Contact(s) Added by This Customer.";
export const CUSTOMER_SETTINGS_TAB_OPTED_OUT_CONTACT_LIST_EMPTY_MSG = "No Contact(s) Have Declined.";

export const LABEL_LAST_FOR_DIGITS = "Last 4 Digits";
export const LABEL_HOURS = "Hour(s)";
export const LABEL_MINUTES = "Minute(s)";
export const LABEL_SECONDS = "Second(s)";

export const LABEL_PROMO_OWNER = "Promo Owner";


export const EXCLUDED_PROMO_PRODUCT_ID = "prod_OUTBJITwOC4ilc";

export const NO_RECORD_FOUND = 'NO RECORD FOUND';
export const PROMO_CODE_DOES_NOT_EXIST = 'Promo code does not exist';
export const EXPIRED_COUPON = 'Expired Coupon.';
export const THE_PROMO_CODE_HAS_EXPIRED = 'The promo code has expired';
export const FREE_AMOUNT = 0;

export const ONBOARDING_STEPS = ['Add Your Info', 'Set Your Secure Calling PIN', 'Billing Details', 'Finish'];
// Countries and US States
export const COUNTRIES = ['United States of America', 'Pakistan'];
export const COUNTRY_CODE_MAP: Record<string, string> = { US: 'United States of America', PK: 'Pakistan' };
export const COUNTRY_OPTION_US = { label: 'United States of America', value: 'USA' } as const;
export const COUNTRY_OPTION_PK = { label: 'Pakistan', value: 'PK' } as const;
export const US_STATES_NAMES = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
];

// Ring My Phone Status
export const RING_MY_PHONE_STATUS = {
  COMPLETED: 'completed',
  PENDING: 'pending',
  FAILED: 'failed',
};

export const REDIRECT_ON_BOARD = 'on-boarding';
export const REDIRECT_CHANGE_PLAN = 'change-plan';

// Ring My Phone Logs table headers
export const LABEL_DATE_AND_TIME = "Date & Time";
export const LABEL_NOTIFICATION_TYPE = "Notification Type";
export const LABEL_CALL_STATUS = "Call Status";
export const LABEL_LOCATION = "Location";
export const LABEL_CALL_CHARGES = "Call Charges";
export const RING_MY_PHONE_LOG_TABLE_HEADERS = [
  LABEL_DATE_AND_TIME, LABEL_NOTIFICATION_TYPE, LABEL_CALL_STATUS,
  LABEL_LOCATION, LABEL_CALL_CHARGES, LABEL_STATUS
];
export const MSG_NO_RMP_LOGS_FOUND = "No ring my phone logs found.";
export const BUTTON_TEXT_VIEW_ON_MAP = "View on Map";
export const BUTTON_TEXT_VIEW = "View";

// Ring My Phone Settings labels
export const LABEL_ENABLE_LOST_PHONE_RINGER = "Enable Lost Phone Ringer";
export const LABEL_ENABLE_LOST_PHONE_LOCATION = "Enable Lost Phone Location";
export const LABEL_DEFAULT_MESSAGE = "Default Message";
export const LABEL_CUSTOM_MESSAGE = "Custom Message";
export const LABEL_SHOW_855_LOGO = "Show 855 Logo";
export const PLACEHOLDER_CUSTOM_MESSAGE = "Enter your custom message here...";
export const MSG_TEXT_LIMIT_EXCEEDED = "Text limit for your message has been exceeded.";
export const MSG_MESSAGE_TOO_SHORT = "Message must be at least 20 characters long.";

// Transaction History table headers (shared across admin and portal)
export const TRANSACTION_HISTORY_TABLE_HEADERS = [LABEL_CREATED_AT, LABEL_DETAILS, LABEL_PAYMENT_METHOD, LABEL_LAST_FOR_DIGITS, LABEL_AMOUNT, LABEL_DISCOUNT, LABEL_RECEIPT, LABEL_STATUS];
// Error & success messages — shared across packages
export const MSG_EMAIL_SENT_SUCCESSFULLY = 'Email has been sent successfully.';
export const MSG_EMAIL_VERIFIED_SUCCESSFULLY = 'Email has been verified successfully.';
export const MSG_PASSWORD_RESET_SUCCESSFULLY = 'Password has been reset successfully.';
export const MSG_PASSWORD_UPDATED_SUCCESSFULLY = 'Password has been updated successfully.';
export const MSG_NAME_UPDATED_SUCCESSFULLY = 'Name has been updated successfully.';
export const MSG_CONTACT_DELETED_SUCCESSFULLY = 'Contact has been deleted successfully.';
export const MSG_CONTACT_ADDED_SUCCESSFULLY = 'Contact has been added successfully.';
export const MSG_FIRST_CONTACT_SUCCESS = (phoneNumber: string): string =>
  `You've successfully added your first trusted contact ${phoneNumber} to your secure Rolodex. They've received a text message letting them know they've been added to your list. To use the service, simply dial ${BRAND_NAME_FULL} (855) 946-3642 from any phone. You'll be connected to the people you've added to your trusted contact list, anytime, anywhere.`;
export const MSG_CONTACT_UPDATED_SUCCESSFULLY = 'Contact has been updated successfully.';
export const MSG_CARD_CHANGED_SUCCESSFULLY = 'Card has been changed successfully.';
export const MSG_CARD_UPDATED_SUCCESSFULLY = 'Card has been updated successfully.';
export const MSG_COUPON_APPLIED_SUCCESSFULLY = 'Coupon has been applied successfully.';
export const MSG_COUPON_CANNOT_BE_APPLIED = 'Coupon cannot be applied.';
export const MSG_STRIPE_NOT_INITIALIZED = 'Stripe is not initialized.';
export const MSG_CARD_ELEMENT_NOT_FOUND = 'Card element not found.';
export const MSG_FILL_CARD_DETAILS = 'Please fill in all card details.';
export const MSG_PLEASE_VERIFY_CAPTCHA = 'Please verify the CAPTCHA.';
export const MSG_PLEASE_SELECT_REFERRAL_SOURCE = 'Please select a referral source.';
export const MSG_PRIORITY_UPDATED = 'Priority has been updated successfully.';
export const MSG_PHONE_NUMBER_ADDED_SUCCESSFULLY = 'Phone number has been added successfully.';
export const MSG_PHONE_NUMBER_UPDATED = 'Phone number has been updated successfully.';
export const LABEL_PHONE_REVERIFY_REQUIRED = 'Action Required';
export const MSG_PHONE_REVERIFY_REQUIRED = (lastFourDigits: string) =>
  `An OTP verification call is needed to ensure your caller ID (...${lastFourDigits}) displays correctly when calling your contacts from a borrowed phone.`;
export const MSG_PLEASE_CHECK_YOUR_PHONE = 'Please check your phone.';
export const MSG_PLEASE_CHECK_YOUR_EMAIL = 'Please check your email.';
export const MSG_INVALID_OR_EXPIRED_LINK = 'Invalid or expired link.';
export const MSG_OTP_VERIFIED = 'OTP has been verified successfully.';
export const MSG_PLAN_UPDATED_SUCCESSFULLY = 'Plan has been updated successfully.';
export const MSG_SUBSCRIPTION_CREATED_SUCCESSFULLY = 'Subscription has been created successfully.';
export const MSG_TOKEN_VERIFIED = 'Token has been verified successfully.';
export const MSG_RMP_INITIATED = 'Ring My Phone™ has been initiated successfully.';
export const MSG_RMP_INITIATION_FAILED = 'Failed to initiate Ring My Phone™.';
export const MSG_PIN_UPDATED = 'PIN has been updated successfully.';
export const MSG_PIN_TOO_SHORT = 'PIN should be 6 digits long.';
export const NOTE_THEN_ABLE_TO_RESET_PIN = "Then, you'll be able to reset your 855WhoDoICall™ custom Secure Calling PIN.";
export const NOTE_ACCOUNT_PASSWORD_SEPARATE_FROM_PIN = "This is the password to log in to your account. This is separate from your Secure Calling PIN, which is used to place calls through 855WhoDoICall™.";
export const NOTE_ACCOUNT_PASSWORD_SEPARATE_FROM_PIN_PREFIX = "This is the password to log in to your account. This is separate from your Secure Calling PIN, which is used to place calls through ";
export const NOTE_ACCOUNT_PASSWORD_SEPARATE_FROM_PIN_SUFFIX = ".";
export const MSG_PLAN_ALREADY_SELECTED = 'Plan is already selected.';
export const MSG_ADD_CARD_FOR_PLAN = 'Please add a card to proceed with the plan update.';
export const MSG_CONTACT_CREATED = 'Contact has been created successfully.';
export const MSG_LOGGED_OUT_SUCCESSFULLY = 'You have been logged out successfully.';
export const MSG_LOGOUT_FAILED = 'Failed to log out.';
export const MSG_CONTACT_DELETE_FAILED = 'Failed to delete contact.';
export const MSG_CONTACT_ORDER_UPDATED = 'Contact order has been updated successfully.';
export const MSG_CONTACT_ORDER_UPDATE_FAILED = 'Could not update order.';
export const NOTE_DRAG_CONTACTS_REORDER = 'To rearrange the order of your contacts, unlock here:';
export const NOTE_TRUSTED_CONTACT_SMS_NOTICE = 'Trusted contacts will be notified via SMS.';

export const LABEL_PHONE_VANITY = '855-WHO-DO-I-CALL';
export const LABEL_PHONE_NUMERIC = '855-946-3642';
export const LABEL_BRAND_WEBSITE = '855WhoDoICall.com';
export const PORTAL_LOGIN_URL = 'https://app.855whodoicall.com/portal/login';

export const RING_MY_PHONE_INFO_MODAL = {
  BULLET_1: "Ring My Phone™ features, including making an audible alert, sending messages to your phone’s lock screen, and locating the phone on a map, can be activated by logging in to your 855WhoDoICall™ account from any internet connection or by calling 855-WHO-DO-I-CALL (or 855-946-3642).",
  BULLET_2: "Ring My Phone™ by 855WhoDoICall™ can serve you better than any other phone locating service when you don’t have access to your other devices. Because, you won’t need to log in to your most important accounts on other people’s devices (which will probably require OTP or email confirmation) to locate your phone. Just simply call 855-WHO-DO-I-CALL (or 855-946-3642), or log in to 855WhoDoICall.com, and immediately activate tools that can help you recover your missing phone.",
  BULLET_3: "Choose your most trusted preset contact to be your 855WhoDoICall™ VIP contact. By default, their number may be shown on your phone when it’s lost, so they can be contacted to help recover your lost phone. The lost phone banner can be changed in the Ring My Phone™ tab of your app or online account.",
} as const;
export const MSG_ACCOUNT_DEACTIVATED_SUCCESSFULLY = 'Account has been deactivated successfully.';
export const MSG_ACCOUNT_DEACTIVATION_FAILED = 'Failed to deactivate account.';
export const MSG_UPDATE_EMAIL_SENT = 'We have sent an email. Please check your inbox.';
export const MSG_UPDATE_EMAIL_FAILED = 'Failed to update email address.';
export const MSG_PLAN_CHANGE_CANCELLED = 'The plan change has been cancelled.';

export const GET_STARTED = {
  TITLE: `Welcome to ${BRAND_NAME_FULL} 👋`,
  DESCRIPTION: `Become prepared with a variety of Phonelessness Services™ for whenever your phone is lost, stolen, damaged, out of battery, or otherwise unavailable.`,
  BUTTON: "Let's Get Started",
} as const;

export const ONBOARDING_ADD_INFO_STRINGS = {
  TITLE: 'Protect Your Mobile Phone',
  DESCRIPTION: "This should be your personal phone number. This is the number that will be attached to your account. When your phone is unavailable, you'll be able to call through 855WhoDoICall™ from any phone, and this is the number that will appear on the caller ID of the phones you'll call. This also allows missing phone locating services.",
  //DESCRIPTION: 'Provide your mobile number so we can help safeguard your phone and your 5 most important contacts with our services.',
  ADD_AND_VERIFY: 'Add and Verify',
  CONTINUE: 'Continue',
  VERIFY: 'Verify',
  CONFIRM: 'Confirm',
  SELECT_AN_OPTION: 'Select an Option',
  HOW_WOULD_YOU_LIKE_TO_VERIFY: 'How would you like to verify?',
  VERIFY_BY_CALL: 'Verify by Call',
  VERIFY_BY_CALL_DESCRIPTION: "We’ll call you now to provide an OTP.",
  VERIFY_BY_CODE: 'Verify by Text Message',
  VERIFY_BY_CODE_DESCRIPTION: "We’ll send an OTP by text message (SMS).",
  TITLE_CHECK_PHONE: 'Please check your phone!',
  CHECK_PHONE_SUBTITLE_SMS: (phone: string) =>
    `Enter the 6-digit OTP sent to your phone number ${phone}. Then, you’ll be able to reset your 855WhoDoICall™ custom Secure Calling PIN.`,
  CHECK_PHONE_SUBTITLE_TPIN: (phone: string, email: string) =>
    `Enter the 6-digit OTP sent to your phone number ${phone} and ${email}. Then, you’ll be able to reset your 855WhoDoICall™ custom Secure Calling PIN.`,
  CHECK_PHONE_SUBTITLE_CALL: (phone: string) =>
    `You'll now receive a call from us. Please pick up your phone at +${phone} and enter the 6-digit confirmation code provided during the call to verify your number.`,
  SUCCESS: 'Phone number added successfully.',
  VERIFIED: 'Your phone number is verified.',
  CALL_FROM_ANY_PHONE_INFO: '855WhoDoICall™ is designed for moments when your own phone is not an option. By calling through 855-WHO-DO-I-CALL (855-946-3642) from any other phone, your trusted contacts will still see your usual caller ID. They\'ll know it\'s you and know to answer exactly when you need them—even though you\'d be using someone else\'s phone.',
  CALL_FROM_ANY_PHONE_INFO_SUFFIX: ' is designed for moments when your own phone is not an option. By calling through 855-WHO-DO-I-CALL (855-946-3642) from any other phone, your trusted contacts will still see your usual caller ID. They\'ll know it\'s you and know to answer exactly when you need them—even though you\'d be using someone else\'s phone.',
} as const;

export const ON_UPDATE_STRINGS = {
  TITLE: "Update Your Personal Phone Number",
  DESCRIPTION: "This should be your personal phone number. This is the number that will be attached to your account. When your phone is unavailable, you'll be able to call through 855WhoDoICall™ from any phone, and this is the number that will appear on the caller ID of the phones you'll call. This also allows missing phone locating services.",
} as const;

export const PHONE_CALL_VERIFY_STRINGS = {
  TITLE: 'Your Mobile Phone Number',
  DESCRIPTION: 'A quick one-time call is needed to ensure your number shows correctly when dialing from a borrowed phone.',
} as const;

export const ONBOARDING_PIN_STRINGS = {
  TITLE: 'Set Your Secure Calling PIN',
  DESCRIPTION: 'Your Secure Calling PIN is used to verify your identity when calling through 855WhoDoICall™.',
  DESCRIPTION_PREFIX: 'Your Secure Calling PIN is used to verify your identity when calling through ',
  DESCRIPTION_SUFFIX: '.',
  CHANGE_DESCRIPTION: 'This action will help you update your 6 digit security code.',
  BUTTON_NEXT: 'Next',
  BUTTON_CHANGE: 'Change PIN Code',
  SUCCESS: 'PIN set successfully.',
} as const;

export const ONBOARDING_SELECT_PLAN_STRINGS = {
  TITLE: 'Phonelessness Services™',
  DESCRIPTION: 'Select Your Plan',
  STEP_TITLE: 'Phonelessness Services™',
  STEP_DESCRIPTION: 'Select Your Plan',
} as const;

export const ONBOARDING_FINISH_STRINGS = {
  TITLE: 'Congratulations!',
  WELCOME: `You’ve opened your account!`,
  BODY: "Continue to the dashboard to add your trusted contacts and discover more about how 855WhoDoICall™ can help you.",
  BODY_PREFIX: "Continue to the dashboard to add your trusted contacts and discover more about how ",
  BODY_SUFFIX: " can help you.",
  BUTTON: 'Go to Dashboard (Add Contacts)',
  SUBSCRIPTION_TITLE: 'Subscription Confirmed!',
  SUBSCRIPTION_BODY: 'Your subscription has been confirmed.',
  SUBSCRIPTION_BUTTON: 'Continue',
  MOBILE_NEW_TITLE: 'Congratulations!',
  MOBILE_NEW_BODY: 'Your subscription is active now. Return to the app to get started.',
  MOBILE_CHANGE_TITLE: 'Plan Updated!',
  MOBILE_CHANGE_BODY: 'Your plan has been updated. Return to the app to continue.',
  CHANGE_TITLE: 'Plan Updated!',
  CHANGE_BODY: 'Your plan has been updated successfully.',
} as const;

export const CHANGE_PLAN_STEPS = [
  { id: 0, title: 'Plans', step: 'Select Plan'},
  { id: 1, title: 'Billing Details', step: 'Add Details'},
  { id: 2, title: 'Finish', step: 'Finish'}, 
] as const;

export const LABEL_EMAIL_CHANGED = "Email Changed";
export const BUTTON_TEXT_DONE = "Done";
export const LABEL_VERIFICATION_CODE = "Verification Code";
export const MSG_VERIFICATION_CODE_EXPIRED = "Verification code has expired.";
export const MSG_VERIFICATION_CODE_EXPIRES_IN = "Your verification code expires in : ";
export const NOTE_VERIFICATION_REFRESH_PAGE = "Once the code is verified, we’ll automatically move you to the next step. If the screen doesn’t update, please refresh.";
export const MSG_DONT_HAVE_CODE = "Didn’t receive the call?";
export const BUTTON_TEXT_RESEND_CODE = "Try Again";
export const MSG_DEV_OTP_NOTICE = "This OTP can only be applied in dev mode and will be turned off later when 10DLC registration is completed. : ";
export const MSG_OTP_EXPIRED = "OTP has expired.";
export const MSG_OTP_EXPIRES_IN = "OTP expires in : ";
export const HEADING_FINISH_ACCOUNT_SETUP = "Let's finish setting up your account!";
export const HEADING_UPDATE_BILLING_DETAILS = "Update Your Billing Details";
export const SUBHEADING_FILL_BILLING_DETAILS = "Please fill out your billing address details and card info.";
export const LABEL_OPTIONAL = "Optional";
export const LABEL_CARD = "Card";
export const LABEL_TERMS_AND_CONDITIONS = "Terms and Conditions";
export const MSG_I_AGREE_TO_THE = "I agree to the";
export const MSG_INCLUDING_TAXES_AND_FEES = "including applicable taxes and usage fees.";
export const BUTTON_TEXT_COMPLETE_CHECKOUT = "Complete Checkout";
export const NOTE_CANCEL_SUBSCRIPTION_30_DAYS = "Cancel anytime. Your service will remain active until the end of your current term.";
export const MSG_SECURE_CREDIT_CARD_PAYMENT = "Secure Credit Card Payment";
export const MSG_SSL_ENCRYPTED_PAYMENT = "This is a secure 128-bit SSL encrypted payment.";
export const LABEL_PLAN_BASIC = "Basic";
export const LABEL_PLAN_STANDARD = "Standard";
export const LABEL_NAME_ON_CARD = "Name on Card";
export const LABEL_CARD_NUMBER = "Card Number";
export const LABEL_EXPIRY_MM_YY = "MM/YY";
export const LABEL_CVC = "CVC";
export const LABEL_CARD_INFORMATION = "Card Information";
export const MSG_FILL_INFO_TO_SAVE = "Please fill out the information to save changes.";
export const LABEL_BILLING = "Billing";
export const LABEL_IMPORTANT = "Important!";
export const MSG_PLAN_UPGRADE_DOWNGRADE_INFO = "While upgrading your plan, you will be charged immediately by adjusting the remaining amount of your current billing plan. If you choose to downgrade your billing plan, it will be effective after the completion of your current plan and system will charge you from its date of effectiveness.";
export const LABEL_SUBSCRIPTION_EXPIRED = "Subscription Expired";
export const TOOLTIP_DRAG_AND_DROP_DISABLED = "Drag and drop disabled";
export const TOOLTIP_DRAG_AND_DROP_ENABLED = "Drag and drop enabled";
export const BUTTON_TEXT_ADD_NEW_CONTACT = "Add new contact";
export const TOOLTIP_CONTACT_LIMIT_REACHED = "Your limit has ended. Click to upgrade your plan and add more contacts.";
export const LABEL_STANDARD_PLAN = "Standard Plan";
export const LABEL_PHONE_LOCATION = "Phone Location";
export const LABEL_CONGRATULATIONS = "Congratulations!";
export const BUTTON_TEXT_OK = "OK";
export const LABEL_SWAP_PRIORITY = "Swap Priority";
export const LABEL_PRIORITY = "Priority";
export const LABEL_APP_NOTIFICATION = "App Notification";
export const LABEL_DECLINE_OF_TRUSTED_CONTACT = "Decline of Trusted Contact";
export const BUTTON_TEXT_DECLINE = "Decline";
export const LABEL_WALLET_PAYMENT = "Wallet Payment";
export const MSG_UPDATE_SECURITY_CODE = "This action will help you update your 6 digit Secure Calling PIN. Your Secure Calling PIN is used to verify your identity when calling through 855WhoDoICall™.";
export const BUTTON_TEXT_CHANGE_PIN_CODE = "Change Secure Calling PIN";
export const HEADING_SIX_DIGIT_PIN_CODE = "Your 6 Digit Secure Calling PIN";
export const LABEL_HOW_DID_YOU_HEAR = "How Did You Hear About Us?";
export const BUTTON_TEXT_SET_VIP = "Set VIP";
export const BUTTON_TEXT_DELETE = "Delete";
export const BUTTON_TEXT_EDIT_CARD = "Edit Card";
export const BUTTON_TEXT_UPDATE_CARD = "Update Card";
export const LABEL_CARD_DETAILS = "Card Details";
export const LABEL_PLAN_FREE = "Free";
export const LABEL_PLAN_POPULAR = "Popular";
export const LABEL_PLAN_MONTHLY = "Monthly";
export const LABEL_PLAN_ANNUAL = "Annual";
export const LABEL_PLAN_ANNUAL_SAVE = "(Almost 50% Off!)";
export const NOTE_TAXES_NOTICE = "* Plus Applicable Taxes";
export const NOTE_DEACTIVATE_ACCOUNT = "Once you deactivate your account, you will not be able to access your data or use our services. This action is permanent and cannot be undone.";
export const BUTTON_TEXT_CURRENT = "Current";
export const BUTTON_TEXT_SELECT = "Select";
export const LABEL_SELECT_SOURCE = "Select Source";
export const LABEL_THIS_MONTH = "This Month";
export const LABEL_TOTAL_USAGE = "Total Usage";
export const MSG_NO_USAGE_DATA = "No usage data available.";
export const MSG_PAYMENT_CONFIRMED_SUCCESSFULLY = "The payment has been confirmed successfully.";
export const BUTTON_TEXT_VERIFY = "Verify";
export const MSG_AGREE_TO_TERMS_PREFIX = "Please click here to agree to the";
export const LABEL_PRIVACY_POLICY = "Privacy Policy";
export const LABEL_CAPTURED_AT = "Captured at: ";
export const MSG_PAY_WITH = "Pay with ";
export const LABEL_APPLE_PAY = "Apple Pay";
export const LABEL_GOOGLE_PAY = "Google Pay";
export const LABEL_STANDARD_PAID_PLAN = "Standard Paid Plan";
export const LABEL_PLAN_YEAR = "Year";
export const LABEL_PLAN_MONTH = "Month";
export const LABEL_PLAN_DAYS = "Day(s)";
export const LABEL_PLAN_WEEK = "Week";
export const TOOLTIP_VIP_CONTACT_INFO = 'Your VIP contact is the person you choose, someone you completely trust, who your phone can be returned to when it’s lost. Although you can customize the message that is displayed with the Ring My Phone™ features of 855WhoDoICall™ to help locate your phone when it’s lost, the default lost phone banner (if you’ve enabled the setting and app permission) includes this VIP contact’s phone number. No other identifying information is revealed by default.';

// Trusted contact opt-out (decline) landing page
export const EMAIL_OPT_IN = 'opt-in@855whodoicall.com';
export const EMAIL_OPT_IN_MAILTO = `mailto:${EMAIL_OPT_IN}`;
export const HEADING_DECLINE_TO_HELP = (name: string): string => `Decline to help ${name}`;
export const NOTE_OPT_OUT_PREFIX = 'Please note, ';
export const NOTE_OPT_OUT_BEFORE_OPTING_OUT = 'BEFORE OPTING OUT';
export const NOTE_OPT_OUT_SUGGEST_CONTACT = ', we suggest you contact ';
export const NOTE_OPT_OUT_MEMBER_CONTACT = (name: string, phoneNo: string): string => `${name} @ ${phoneNo}`;
export const NOTE_OPT_OUT_EXPLAIN_SERVICES = ' so they can explain our trusted calling services to you.';
export const NOTE_OPT_OUT_EMAIL_PREFIX = ' If you opt-out now, you will have to send us an email (';
export const NOTE_OPT_OUT_EMAIL_SUFFIX = ') to request to opt back in as a trusted contact for ';
export const NOTE_OPT_OUT_SUFFIX = ' in the future.';

